import dayjs from "dayjs";
import { Tournament_Results, useGetPartiesQuery } from "generated/graphql";
import { roundAccurately } from "lib/rounding";

function LeaderboardTable({
  tournamentId,
  leaderboardData,
}: {
  tournamentId: string;
  leaderboardData: Tournament_Results[];
}) {
  let { data: participants, loading: loadingParticipants } = useGetPartiesQuery(
    {
      variables: {
        partyIds: leaderboardData
          .map((result) => result.result["actualParticipants"])
          .reduce((acc, val) => [...acc, ...val], []),
      },
      nextFetchPolicy: "cache-first",
    }
  );
  // @ts-ignore
  participants =
    !loadingParticipants && participants!
      ? participants.parties.reduce(
          (acc, val) => ({ ...acc, [val.id]: val.name }),
          {}
        )
      : {};

  return (
    <>
      {leaderboardData.map((matchResult) => (
        <div className="tournament-results-wrapper">
          <h4>{matchResult.match.name}</h4>
          <h5>
            {matchResult.result.actualParticipants.map(
              // @ts-ignore
              (partyId: string) => participants[partyId]
            ).join(' v. ')}
          </h5>
          <table
            id="leaderboardTable"
            key={matchResult.id}
            style={{ marginLeft: 0 }}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Rank</th>
                <th>Points</th>
                <th>KDA</th>
                {/* <th>Cash Won</th> */}
              </tr>
            </thead>
            <tbody>
              {matchResult.result.actualParticipants.map((partyId: string) => (
                <tr
                  key={`result-${partyId}`}
                  className={
                    matchResult.result.placing[partyId] === 1 ? "bold" : ""
                  }
                >
                  <td>
                    {dayjs(matchResult.match.match_time.split("T")[0]).format(
                      "D MMM YYYY"
                    )}
                  </td>
                  <td>
                    {
                      // @ts-ignore
                      participants[partyId]
                    }
                  </td>
                  <td>{matchResult.result.placing[partyId]}</td>
                  <td>{matchResult.result.points[partyId]}</td>
                  <td>{roundAccurately(matchResult.result.kda[partyId], 3)}</td>
                  {/* <td>-</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
}

export default LeaderboardTable;
